module.exports = __webpack_public_path__ + "static/img/fuwulb.6f99bf49.png";